import { defineExperiment } from '@cian/experiments/ab';

export const BX_MOBILE_BX687_NEW_MAINPAGE_EXPERIMENT = 'bx_mobile_bx687_new_mainpage';

export const BxMobileBx687NewMainpageExperiment = defineExperiment(BX_MOBILE_BX687_NEW_MAINPAGE_EXPERIMENT, {
  default: 'A',
  groups: ['A', 'B'] as const,
});
